import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard PRO React example components
import PageLayout from "examples/LayoutContainers/PageLayout";
import DataTable from "examples/Tables/DataTable";
import AppData from "./components/data-tables/data/dataTableData"
import Loader from "examples/Loader";
import { Link, useNavigate } from "react-router-dom";
function Accounts() {
    const { dataTableData, handleRefresh, loader } = AppData()
    const navigate = useNavigate();
    return (
        loader ?
            <Loader />
            :
            <PageLayout>
                <SoftBox pt={6} pb={3}>
                    <Grid container spacing={6}>
                        <Grid item xs={12}>
                            <Card>
                                <SoftBox
                                    mx={2}
                                    py={3}
                                    px={2}
                                    variant="outlined"
                                    bgColor="dark"
                                    borderRadius="lg"
                                    coloredShadow="dark"
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center  "
                                >
                                    <div style={{ display: "flex" }}>
                                        <span style={{ color: "white", fontSize: "16px" }} onClick={() => navigate(-1)}>Go back / </span>
                                        <SoftTypography variant="h6" color="white">
                                            Accounts
                                        </SoftTypography>
                                    </div>

                                </SoftBox>
                                <SoftBox pt={3} px={3}>
                                    <DataTable table={dataTableData} canSearch />
                                </SoftBox>
                            </Card>
                        </Grid>
                    </Grid>
                </SoftBox>
            </PageLayout>
    );
}

export default Accounts;
